import React, { useContext } from 'react';
import { SchoolContext } from '../../context/SchoolContext';
import CourseList from './CourseList';
import AddCourse from './AddCourse';
import Card from '../ui/Card';

const CourseManagement = () => {
    const { courses, setCourses } = useContext(SchoolContext);

    return (
        <Card title="Course Management">
            <AddCourse setCourses={setCourses} />
            <CourseList courses={courses} />
        </Card>
    );
};

export default CourseManagement;
